<template>
  <v-data-table
    dense
    show-expand
    :headers="headers"
    :items="minigenres"
    :items-per-page="-1"
    :footer-props="{
      'items-per-page-options': [1, 2, 3, 5, -1]
    }"
    item-key="minigenreId"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Minigenre</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-switch
          v-model="singleExpand"
          label="Single expand"
          class="mt-2"
        ></v-switch>
      </v-toolbar>
    </template>
    <template v-slot:expanded-item="{ item }">
      <td :colspan="headers.length">
        <table class="minigenre-titles">
          <thead>
            <tr>
              <th class="pl-2 text-start">IMDb Id</th>
              <th class="pl-2 text-start">Title</th>
              <th class="pl-2 text-start">Year</th>
              <th class="pl-2 text-start">Type</th>
              <th class="pl-2 text-start">Crowd Rating</th>
              <th class="pl-2 text-start">Crowd Size</th>
              <th class="pl-2 text-start">Distance</th>
            </tr>
          </thead>
          <tr v-for="el in item.minigenreTitles" :key="el.imdbId">
            <td>
              <a
                target="_blank"
                :href="el.imdbLink"
                style="text-decoration: none"
                >{{ el.imdbId }}</a
              >
            </td>
            <td>
              <div @click="onTitleClicked(el.ncTitleId)" class="hand-cursor">{{ el.title }}</div>
            </td>
            <td>{{ el.year }}</td>
            <td>{{ el.type }}</td>
            <td>{{ el.crowdRating }}</td>
            <td>{{ el.crowdSize }}</td>
            <td>{{ el.distance.toFixed(1) }}</td>
          </tr>
        </table>
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  data: () => ({
    expanded: [],
    singleExpand: true,
    headers: [
      {
        text: 'Score',
        sortable: false,
        align: 'start',
        value: 'score'
      },
      { text: 'mgID', sortable: false, value: 'minigenreId' },
      { text: 'Name', sortable: false, value: 'minigenreName' },
      {
        text: 'Minigenre keywords',
        sortable: false,
        value: 'minigenreKeywords'
      },
      { text: '', value: 'data-table-expand' }
    ]
  }),
  methods: {
    onTitleClicked(ncTitleId) {
      this.$router.safePush(`/title/${ncTitleId}`)
    }
  },
  computed: {
    minigenres() {
      const minigenres = this.$store.getters['title/getMinigenres']()
      if (minigenres) {
        const minigenreList = minigenres.map((item) => {
          item.minigenreTitles.map((el) => {
            el.imdbLink = `https://www.imdb.com/title/${el.imdbId}`
          })
          return {
            minigenreName: item.label,
            score: item.score,
            minigenreId: item.minigenreId,
            minigenreKeywords: item.minigenreKeywords
              .map((el) => el.keyword)
              .join(' • '),
            minigenreTitles: item.minigenreTitles
          }
        })
        return minigenreList
      } else {
        return []
      }
    }
  }
}
</script>
<style scoped>
.minigenre-titles {
  position: relative;
  margin: 10px auto;
  padding: 0;
  width: 100%;
  height: auto;
  border-collapse: collapse;
  text-align: start;
}

.minigenre-titles tr {
  margin: 0;
  padding: 0;
  border: 0;
  border: 1px solid #999;
  width: 100%;
}

.minigenre-titles tr td {
  margin: 0;
  padding: 4px 8px;
  border: 0;
  border: 1px solid #999;
}

.hand-cursor {
  cursor: pointer;
  color: #1976d2;
}
</style>
